module.exports = __webpack_public_path__ + "static/media/wheel-pointer@2x.39d8160f.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_120/imgs/wheel-pointer@2x.png
// module id = 1117
// module chunks = 0